import React from 'react';

import { FlexCol, FlexRow, TitleSmall } from '../../../common/components/v2';
import { Resource } from '../../../common/constants/resource';
import { HttpService } from '../../../common/http.service';
import { formatSiblingDetailLine } from '../../qeInterviewQa/utils';
import styles from '../styles.module.scss';

export const QEInterviewQnA = ({
  policyId,
  carrierPolicyNumber,
}: {
  policyId: number;
  carrierPolicyNumber: string;
}) => {
  const resource = ((): string => {
    return Resource.QE_INTERVIEW_QNA;
  })();
  const onClick = async () => {
    const url = `applications/${policyId}/interviewExport`;
    const resp = await HttpService.getInstance().get(url);
    const newTab = window.open('', 'Interview Q&A', 'width=800,height=400');
    if (newTab) {
      buildInterviewHTML(newTab, resp.parsedBody);
    }
  };

  const buildInterviewHTML = (tab: Window, interviewExport: any) => {
    if (!interviewExport) {
      tab.document.write(
        `<p>Error when pulling interview data for ${carrierPolicyNumber}</p>`,
      );
      return;
    }
    let questionNumber = 0;
    const answerUuidToText = new Map<string, string>();

    const handleAsk = (ask: any) => {
      // print question
      questionNumber++;
      tab.document.write(`<h3> ${questionNumber}) ${ask.questionPrompt}</h3>`);

      // print answer choices
      if (ask?.answerChoices && ask.answerChoices.length) {
        ask.answerChoices.forEach((choices: any) => {
          answerUuidToText.set(choices.answerUUID, choices.text);
          tab.document.write(`<p><i> - ${choices?.text}</i></p>`);
        });
      }

      // print answers and recursively handle Ask if needed
      let hasRelatedAsk = false;
      ask.answers.forEach((answer: any) => {
        if (answer?.answerUUID && answerUuidToText.has(answer.answerUUID)) {
          tab.document.write(
            `<p><b>Answer: ${answerUuidToText.get(answer.answerUUID)}</b></p>`,
          );
        } else {
          tab.document.write(`<p><b>Answer: ${answer.value}</b></p>`);
        }

        if (answer?.metadata?.siblings?.length) {
          tab.document.write('<ul>');
          answer.metadata.siblings.forEach((sibling: any, idx: number) => {
            tab.document.write(
              `<li>${formatSiblingDetailLine(sibling, idx)}</li>`,
            );
          });
          tab.document.write('</ul>');
        }

        if (answer?.relatedAsks?.length) {
          hasRelatedAsk = true;
          tab.document.write(`<br>`);
          answer.relatedAsks.forEach((relatedAsk: any) => {
            handleAsk(relatedAsk);
          });
        }
      });

      if (!hasRelatedAsk) {
        tab.document.write(`<br>`);
      }
    };

    tab.document.body.innerHTML = '';
    const title = `${carrierPolicyNumber} Interview Q&A`;
    tab.document.write(`<title>${title}</title>`);
    tab.document.write(`<h1>${title}</h1>`);
    tab.document.write(`<hr>`);

    const interview = interviewExport.interview;
    for (const sectionObj of interview) {
      tab.document.write(`<h2> Section: ${sectionObj.sectionName}</h2>`);
      for (const ask of sectionObj.asks) {
        handleAsk(ask);
      }
    }
  };

  return (
    <>
      <FlexRow className={styles.Title} data-section-id={'QE Interview QnA'}>
        <TitleSmall>{resource}</TitleSmall>
      </FlexRow>
      <FlexRow className={styles.MarginTop}>
        <FlexCol sm={3} className={styles.TaskLeftCell}>
          {resource}
        </FlexCol>
        <FlexCol lg={6} className={styles.TaskInfoCell}>
          <button type={'button'} className={styles.Document} onClick={onClick}>
            {`${carrierPolicyNumber}-interviewQ&A`}
          </button>
        </FlexCol>
      </FlexRow>
    </>
  );
};
